import React, { useState } from 'react';
import './sketch.css';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { sketchData } from '../../Data/sketchData';
import { Link } from 'react-router-dom';


function Sketch({showAllSketch}) {
    const sketchDisplay = showAllSketch ? sketchData : sketchData.slice(0,4);
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);

    const images = sketchDisplay.map(item => item.img);

    const handleCardClick = index => {
        setPhotoIndex(index);
        setIsOpen(true);
    };

  return (
    <div className='sketch'>
        <div className="sketch-container">
            <div className="gallery">
            {sketchDisplay.map(({ title, img }, index) => (
                <div className="img-box" onClick={() => handleCardClick(index)} key={index} style={{ backgroundImage: `url(${img})` }}>
                    <h3>{title}</h3>
                </div>
            ))}
            {isOpen && (
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
                />
            )}
            </div>
                <Link to='/sketches' className='see-sketch-a'>
                    <div className="see-sketch-a-hover"></div>
                    <div className="see-more-sketch">
                            see more
                    </div>
                </Link>
        </div>
    </div>
  )
}

export default Sketch